var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInformation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M7.5 0.109375C3.48633 0.109375 0.234375 3.39062 0.234375 7.375C0.234375 11.3887 3.48633 14.6406 7.5 14.6406C11.4844 14.6406 14.7656 11.3887 14.7656 7.375C14.7656 3.39062 11.4844 0.109375 7.5 0.109375ZM7.5 13.2344C4.24805 13.2344 1.64062 10.627 1.64062 7.375C1.64062 4.15234 4.24805 1.51562 7.5 1.51562C10.7227 1.51562 13.3594 4.15234 13.3594 7.375C13.3594 10.627 10.7227 13.2344 7.5 13.2344ZM7.5 3.33203C6.79688 3.33203 6.26953 3.88867 6.26953 4.5625C6.26953 5.26562 6.79688 5.79297 7.5 5.79297C8.17383 5.79297 8.73047 5.26562 8.73047 4.5625C8.73047 3.88867 8.17383 3.33203 7.5 3.33203ZM9.14062 10.7734V10.0703C9.14062 9.89453 8.96484 9.71875 8.78906 9.71875H8.4375V6.78906C8.4375 6.61328 8.26172 6.4375 8.08594 6.4375H6.21094C6.00586 6.4375 5.85938 6.61328 5.85938 6.78906V7.49219C5.85938 7.69727 6.00586 7.84375 6.21094 7.84375H6.5625V9.71875H6.21094C6.00586 9.71875 5.85938 9.89453 5.85938 10.0703V10.7734C5.85938 10.9785 6.00586 11.125 6.21094 11.125H8.78906C8.96484 11.125 9.14062 10.9785 9.14062 10.7734Z",
    fill: "#E16058"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.b3ce4ac1.svg";
export { ForwardRef as ReactComponent };